import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_252: DocMigration = {
  maxSchemaVersion: "0.0.252",
  description: "Migrates stair foundation pattern datums to new relative datums",
  apply(json: any) {
    if (json.stairBlocks) {
      for (const stairBlockId of Object.keys(json.stairBlocks)) {
        const stairBlock = json.stairBlocks[stairBlockId];
        const foundationPatterns = stairBlock?.foundationPatterns;
        if (foundationPatterns) {
          for (const foundationPatternId in foundationPatterns) {
            const foundationPattern = foundationPatterns[foundationPatternId].foundationPattern;
            if (foundationPattern) {
              delete foundationPattern.topOfFoundation;
              const topOffset = foundationPattern.postTopOffset;
              delete foundationPattern.postTopOffset;
              const verticalDatum = {
                type: "RELATIVE",
                topDatumId: "STAIR_SYSTEM",
                bottomDatumId: "BOTTOM_OF_STAIR_SYSTEM_HOST",
              };
              foundationPatterns[foundationPatternId].foundationPattern = topOffset
                ? {
                    ...foundationPattern,
                    ["verticalDatum"]: { ...verticalDatum, topOffset: topOffset },
                  }
                : {
                    ...foundationPattern,
                    ["verticalDatum"]: { ...verticalDatum },
                  };
            }
          }
        }
      }
    }
    return json;
  },
};

export default migration_0_0_252;
